import * as types from 'misc/types';
import * as actions from 'misc/actions';

const customer = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_CUSTOMER_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_CUSTOMER_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_CUSTOMER_GET.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_CUSTOMER_POST.REQUEST:
            return actions.load(state);
        case types.SAGA_CUSTOMER_POST.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_CUSTOMER_POST.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_CUSTOMER_PUT.REQUEST:
            return actions.load(state);
        case types.SAGA_CUSTOMER_PUT.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_CUSTOMER_PUT.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_CUSTOMER_DELETE.REQUEST:
            return actions.load(state);
        case types.SAGA_CUSTOMER_DELETE.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_CUSTOMER_DELETE.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default customer;



// WEBPACK FOOTER //
// ./src/reducers/customer.js